import firebase from 'firebase/app';
import 'firebase/database';

class BetStore {
    constructor() {
        this.database = null;

        if (typeof window !== 'undefined') {
            this.initFirebase();
        }
    }

    initFirebase() {
        const app = firebase.initializeApp({
            apiKey: 'AIzaSyCXWOjd4vGXoRSoWwyw0sPcCFjDU8CVRx0',
            authDomain: "babybets-7d119.firebaseapp.com",
            databaseURL: 'https://babybets-7d119.firebaseio.com',
            projectId: 'babybets-7d119',
        });

        this.database = app.database();
    }

    addBetToDatabase(formData, errorCallback, successCallback) {
        const DBRef = this.database.ref('paris');

        const refAdd = DBRef.push(formData, (err) => {
            if (err) {
                errorCallback();
            } else {
                successCallback();
            }
        });

        // Need to store this
        this.storeUserBet(refAdd.key);
    }

    getBets(callback) {
        const DBRef = this.database.ref('paris');

        DBRef.on("value", (snapshot) => {
            callback(snapshot.val());
        }, (errorObject) => {
            console.log(errorObject);
        });
    }

    storeUserBet(id) {
        if (typeof window !== 'undefined') {
            localStorage.setItem('userBetID', id)
        }
    }

    getUserBet() {
        // This fucks off for now
        // if (typeof window !== 'undefined') {
        //     if (localStorage.getItem('userBetID')) {
        //         return localStorage.getItem('userBetID');
        //     } else {
        //         return null;
        //     }
        // }

        return false;
    }
}

export default new BetStore()
